import React, { useState } from 'react';
import axios from 'axios';
import './CreatePost.css';

function CreatePost({ onPostCreated }) {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [articleUrl, setArticleUrl] = useState('');
  const [linkPreview, setLinkPreview] = useState(null);

  const handleFetchPreview = async () => {
    const url = articleUrl.trim();
    if (!url) return;

    setPreviewLoading(true);
    try {
      const response = await axios.get('/api/link-preview', { params: { url } });
      setLinkPreview(response.data);
      if (!content.trim() && response.data.title) {
        setContent(response.data.title);
      }
    } catch (error) {
      console.error('Error fetching link preview:', error);
      alert('Failed to fetch link preview');
    } finally {
      setPreviewLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!linkPreview) {
      alert('Please fetch the article link preview first');
      return;
    }

    setLoading(true);
    try {
      const payload = {
        content: content.trim() || linkPreview.title || '',
        postType: 'ARTICLE',
        linkUrl: linkPreview.url,
        linkTitle: linkPreview.title,
        linkDescription: linkPreview.description,
        linkImage: linkPreview.image
      };

      const response = await axios.post('/api/posts', payload);

      onPostCreated(response.data);
      setContent('');
      setArticleUrl('');
      setLinkPreview(null);
    } catch (error) {
      const message = error.response?.data?.message || 'Failed to create post';
      alert(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-post-card">
      <form onSubmit={handleSubmit}>
        <textarea
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder="Add a comment about this article (optional)"
          maxLength="500"
          rows="3"
        />

        <div className="post-type-fields">
          <div className="field-row">
            <input
              type="url"
              value={articleUrl}
              onChange={(e) => {
                setArticleUrl(e.target.value);
                setLinkPreview(null);
              }}
              placeholder="Paste article URL..."
              className="field-input"
            />
            <button
              type="button"
              className="secondary-btn"
              onClick={handleFetchPreview}
              disabled={previewLoading || !articleUrl.trim()}
            >
              {previewLoading ? 'Fetching...' : 'Fetch Preview'}
            </button>
          </div>

          {linkPreview && (
            <div className="link-preview-card">
              {linkPreview.image && (
                <img src={linkPreview.image} alt="" className="link-preview-image" />
              )}
              <div className="link-preview-body">
                <div className="link-preview-title">{linkPreview.title || linkPreview.url}</div>
                {linkPreview.description && (
                  <div className="link-preview-description">{linkPreview.description}</div>
                )}
                <div className="link-preview-url">{linkPreview.url}</div>
              </div>
              <button type="button" className="remove-preview-btn" onClick={() => setLinkPreview(null)}>
                Remove
              </button>
            </div>
          )}
        </div>

        <div className="create-post-footer">
          <button
            type="submit"
            className="post-btn"
            disabled={loading || !linkPreview}
          >
            {loading ? 'Posting...' : 'Post'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default CreatePost;
